import type {
  PublicationFetchForTopicAction,
  PublicationFetchForTopicFailureAction,
  PublicationFetchForTopicPayload,
  PublicationFetchForTopicSuccessAction,
} from "entities/publication/actionTypes";
import { PublicationActionTypes } from "entities/publication/actionTypes";

export const fetchPublicationForTopic = (
  payload: PublicationFetchForTopicPayload,
  meta?: { forceRefresh?: boolean },
): PublicationFetchForTopicAction => ({
  meta: meta ?? { forceRefresh: false },
  type: PublicationActionTypes.FETCH_FOR_TOPIC,
  payload,
});

export const fetchPublicationForTopicSuccess = (
  payload: PublicationFetchForTopicSuccessAction["payload"],
  meta: PublicationFetchForTopicSuccessAction["meta"],
): PublicationFetchForTopicSuccessAction => ({
  type: PublicationActionTypes.FETCH_FOR_TOPIC_SUCCESS,
  payload,
  meta,
});

export const fetchPublicationForTopicFailure = (
  meta: PublicationFetchForTopicFailureAction["meta"],
): PublicationFetchForTopicFailureAction => ({
  type: PublicationActionTypes.FETCH_FOR_TOPIC_FAILURE,
  meta,
});
